// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters {
  padding: 2em 2em 0;
}
.filters .actions .mat-spinner {
  display: inline-block;
}
.filters .instructions {
  display: inline-block;
  vertical-align: top;
  margin-right: 1em;
  margin-top: 1.5em;
}
.resources {
  padding: 2em;
  display:flex;
  align-items:flex-start;
  align-content:flex-start;
  gap:0.5rem 1rem;
  flex-wrap:wrap;
}
.resource {
  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 80%), 0 1px 1px 0 rgb(0 0 0 / 80%), 0 1px 3px 0 rgb(0 0 0 / 80%);
  width:100%;
}
.resource .action a {
  color: rgba(0, 0, 0, 0.87);
}
:host ::ng-deep .mat-chip-list-wrapper {
  display: inline-block;
  margin-right: 1em;
}

.mdc-card__actions {
  gap:1rem;
}

@media only screen and (min-width:30em) {
  .resource {
    align-items: center;
  }
  .resource .header {
    display:inline-block;
    width:50%;
    vertical-align:top;
  }
  .resource .header a {
    text-align:left;
  }
  .resource .action {
    vertical-align:top;
    display:inline-block;
    width:50%;
    text-align:right;
  }
  .resource .action a {
    width:auto;
  }
}
@media only screen and (min-width:36em) {
  .filters .actions {
    margin-top: 1em;
    float: right;
  }
}

@media only screen and (max-width:29em) {
  .resource {
    text-align: center;
  }
  .resource .header .name {
    margin-bottom: 1em;
  }
  .resource .action a {
    margin-top: 1em;
  }
  .loading-spinner {
    display: flex;
    justify-content: center;
  }
}

.resource  {
  min-height:6rem;
}

@media only screen and (min-width:50em) {
  .resource {width:48%;}
}

@media only screen and (min-width:70em) {
  .resource {width:30%;}
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/resource/resource.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;AACA;EACE,uGAAuG;EACvG,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW,SAAS,CAAC;AACvB;;AAEA;EACE,WAAW,SAAS,CAAC;AACvB","sourcesContent":[".filters {\n  padding: 2em 2em 0;\n}\n.filters .actions .mat-spinner {\n  display: inline-block;\n}\n.filters .instructions {\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 1em;\n  margin-top: 1.5em;\n}\n.resources {\n  padding: 2em;\n  display:flex;\n  align-items:flex-start;\n  align-content:flex-start;\n  gap:0.5rem 1rem;\n  flex-wrap:wrap;\n}\n.resource {\n  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 80%), 0 1px 1px 0 rgb(0 0 0 / 80%), 0 1px 3px 0 rgb(0 0 0 / 80%);\n  width:100%;\n}\n.resource .action a {\n  color: rgba(0, 0, 0, 0.87);\n}\n:host ::ng-deep .mat-chip-list-wrapper {\n  display: inline-block;\n  margin-right: 1em;\n}\n\n.mdc-card__actions {\n  gap:1rem;\n}\n\n@media only screen and (min-width:30em) {\n  .resource {\n    align-items: center;\n  }\n  .resource .header {\n    display:inline-block;\n    width:50%;\n    vertical-align:top;\n  }\n  .resource .header a {\n    text-align:left;\n  }\n  .resource .action {\n    vertical-align:top;\n    display:inline-block;\n    width:50%;\n    text-align:right;\n  }\n  .resource .action a {\n    width:auto;\n  }\n}\n@media only screen and (min-width:36em) {\n  .filters .actions {\n    margin-top: 1em;\n    float: right;\n  }\n}\n\n@media only screen and (max-width:29em) {\n  .resource {\n    text-align: center;\n  }\n  .resource .header .name {\n    margin-bottom: 1em;\n  }\n  .resource .action a {\n    margin-top: 1em;\n  }\n  .loading-spinner {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.resource  {\n  min-height:6rem;\n}\n\n@media only screen and (min-width:50em) {\n  .resource {width:48%;}\n}\n\n@media only screen and (min-width:70em) {\n  .resource {width:30%;}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
